import { region as getRegion } from '@/utils/utils'
import {
  countryOfThousSeparator,
  countryOfDecimalPointSeparator,
  countryOfDecimalPlaces,
  countryOfSymbolInAfter,
} from '@/config/country'

// 金额千分位和小数点规则
// 千分位分隔符
export const thous_separator = countryOfThousSeparator()
//小数点分隔符
export const decimal_point_separator = countryOfDecimalPointSeparator()
// 小数位数
export const decimalPlaces = countryOfDecimalPlaces()
// 货币符号是否在后面
export const SymbolInAfter = countryOfSymbolInAfter()

const region = getRegion()

export const moneyFormatRules = {
  decimal: decimal_point_separator[region], // 小数点符号
  separator: thous_separator[region], // 千分位符号
  decimalPlaces: decimalPlaces[region], // 小数位数
  SymbolInAfter: SymbolInAfter[region], // 货币符号是否在后面
}
